/*
    Business logic menu data added during development
    roles: 0: Registered user:, 1:administrators, 9:Menu for login page display only
*/
/* Layout */
import ustnFinance from "./ustnFinance.js";
import bidStake from "./bidStake.js";
import governance from "./governance.js";
import transfer from "./transfer.js";
import stake from "./stake.js";

const menuRoutes = [
  {
    component: () => import("@/views/index"),
    path: "/Stake",
    alwaysShow: false,
    name: "Stake",
    redirect: "noRedirect",
    meta: {
      title: "Staking",
      icon: ""
    },
    children: [...stake]
  },
  // {
  //   component: () => import('@/views/index'),
  //   path: "/bidStake",
  //   alwaysShow: false,
  //   name: "bidStake",
  //   redirect: "noRedirect",
  //   meta: {
  //     title: "Bidding",
  //     icon: "",
  //   },
  //   children: [
  //     ...bidStake
  //   ],
  // },
  {
     component: () => import('@/views/index'),
     path: "/TCashFinance",
     alwaysShow: false,
     name: "TCashFinance",
     redirect: "noRedirect",
     meta: {
       title: "TCash Finance",
       icon: "",
     },
     children: [
       ...ustnFinance
     ],
  },
  /*{
    component: () => import('@/views/index'),
    path: "/Governance",
    alwaysShow: false,
    name: "Governance",
    redirect: "noRedirect",
    meta: {
      title: "Governance",
      icon: "",
    },
    children: [
      ...governance
    ],
  },*/
  {
    component: () => import("@/views/index"),
    path: "/bridge",
    alwaysShow: false,
    name: "transfer",
    redirect: "noRedirect",
    meta: {
      title: "Bridge",
      icon: ""
    },
    children: [...transfer]
  }
];
export default menuRoutes;
